import React from 'react'
import { Container, Radio } from '@cleartrip/ct-design-components'
import { Raven } from '@/analytics/raven'
import { RAVEN_ATTRIBUTE_NAME, RAVEN_EVENT_NAME, RAVEN_PAGE_NAME } from '@/analytics/raven/ravenConstants'
import { EMPTY_BLOCK_FUNCTION } from '@/constants/pages/common'

interface JourneyTypeProps {
    journeyType: string
    tripTypeHandler: (arg0: string) => void
}

const JourneyType: React.FC<JourneyTypeProps> = ({ journeyType, tripTypeHandler }) => {
    const isOneWay = journeyType === 'O'
    const isRoundTrip = journeyType === 'R'

    const handleTripTypeChange = (value: 'O' | 'R') => {
        tripTypeHandler(value)
        
        // Track analytics
        Raven.push({
            eventName: `a_hp_${value === 'O' ? 'ow' : 'rt'}_journey_clicked`,
            eventData: {
                action_name: `a_hp_${value === 'O' ? 'ow' : 'rt'}_journey_clicked`,
                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME
            }
        })
        
        // Track journey clicked event
        Raven.push({
            eventName: RAVEN_EVENT_NAME.HOME_JOURNEY_CLICKED,
            eventData: {
                action_name: RAVEN_ATTRIBUTE_NAME.HP_JOURNEY_CLICKED,
                page_name: RAVEN_PAGE_NAME.FLIGHTS_HOME
            }
        })
    }

    return (
        <Container className="flex flex-middle" style={{ gap: '20px' }}>
            <Container 
                className="flex flex-middle"
                cursor="pointer"
                onClick={(event) => {
                    event.stopPropagation()
                    handleTripTypeChange('O')
                }}
            >
                <Radio
                    name="journeyType"
                    value="O"
                    id="oneway"
                    label="One way"
                    checked={isOneWay}
                    onChange={EMPTY_BLOCK_FUNCTION}
                    gap="8px"
                    labelVariant="B1"
                />
            </Container>
            <Container 
                className="flex flex-middle"
                cursor="pointer"
                onClick={(event) => {
                    event.stopPropagation()
                    handleTripTypeChange('R')
                }}
            >
                <Radio
                    name="journeyType"
                    value="R"
                    id="roundtrip"
                    label="Round trip"
                    checked={isRoundTrip}
                    onChange={EMPTY_BLOCK_FUNCTION}
                    gap="8px"
                    labelVariant="B1"
                />
            </Container>
        </Container>
    )
}

export default JourneyType
